import { Component, OnInit } from '@angular/core';
import { ShareDataService } from 'projects/shared/src/app/shared/share-data.service';

@Component({
  selector: 'c-feedback',
  templateUrl: './candidate-feedback.component.html',
  styleUrls: ['./candidate-feedback.component.css']
})
export class CandidateFeedbackComponent implements OnInit {
  batchDetails: any;
  constructor(
    private sharedService: ShareDataService
  ) { }

  ngOnInit() {
    console.log('LELELE');
    
    this.sharedService.getBatchDataForFeedbackForm().subscribe(batch => {
      this.batchDetails = batch;
    })
  }

}
